export default __webpack_public_path__ + "assets/icons/enterprise_login.43325636.svg";